import {
  type Category,
  normalizeCategoryLarge,
} from "../common/commonConstant";

/** 収支一覧画面の直近の検索条件を保存するlocalStorageのキー（ログアウト時に削除する） */
export const RECENT_SEARCHES_STORAGE_KEY = "bop020w020RecentSearches";

/** 除外条件1組分。項目（小）が空の場合は項目（大）全体を除外する */
export interface ExcludeCondition {
  categoryLarge: string;
  categorySmall: string;
}

/** 除外条件の組数（各組はOR条件で、いずれかに該当する行を除外する） */
export const EXCLUDE_CONDITION_COUNT = 3;

export const createEmptyExcludeConditions = (): ExcludeCondition[] =>
  Array.from({ length: EXCLUDE_CONDITION_COUNT }, () => ({
    categoryLarge: "",
    categorySmall: "",
  }));

/**
 * 直近の検索条件（localStorage）や画面遷移のstateから復元した除外条件を、
 * 常にEXCLUDE_CONDITION_COUNT組・項目（大）正規化済みの形に揃える。
 * 除外条件が1組だった頃の形式（excludeCategoryLarge / excludeCategorySmall）も読み替える。
 */
export const normalizeExcludeConditions = (condition: {
  excludeConditions?: Partial<ExcludeCondition>[];
  excludeCategoryLarge?: string;
  excludeCategorySmall?: string;
}): ExcludeCondition[] => {
  const source = Array.isArray(condition.excludeConditions)
    ? condition.excludeConditions
    : [
        {
          categoryLarge: condition.excludeCategoryLarge,
          categorySmall: condition.excludeCategorySmall,
        },
      ];
  return createEmptyExcludeConditions().map((empty, index) => {
    const item = source[index];
    if (!item) return empty;
    return {
      categoryLarge: normalizeCategoryLarge(item.categoryLarge || ""),
      categorySmall: item.categorySmall || "",
    };
  });
};

/**
 * 収支一覧画面（BOP020W020）の検索条件。
 * BOP020W020とBOP020W010（登録画面から一覧画面へ戻る際の再検索）で共有する。
 */
export interface SearchCondition {
  type: Category;
  categoryLarge: string;
  categorySmall: string;
  amountFrom: string;
  amountTo: string;
  dateFrom: string;
  dateTo: string;
  memo: string;
  keihiFlg: "" | "0" | "1";
  mikakuteiFlg: "" | "0" | "1";
  /** 除外条件（任意、EXCLUDE_CONDITION_COUNT組のOR条件） */
  excludeConditions: ExcludeCondition[];
}

/**
 * 遷移先画面から遷移前の画面へ「戻る」際に、遷移前の検索結果を復元するための情報。
 * BOP020W030→BOP020W020、BOP020W020→BOP020W010の双方の遷移で
 * `navigate(path, { state })` に載せて運び、戻り先でこの内容をもとに再検索する。
 * さらに遷移前の`returnTo`をネストして運ぶことで、複数画面をまたいだ
 * 「戻る」の連鎖（例: 月次集計→一覧→登録→一覧→月次集計）にも対応する。
 */
export interface ReturnTo {
  pathname: string;
  month?: string;
  searchSnapshot?: SearchCondition;
  page?: number;
  sortKey?: string;
  sortDirection?: "asc" | "desc";
  returnTo?: ReturnTo;
}
